import {keys as breakpoints} from '@material-ui/core/styles/createBreakpoints';
import * as _ from 'lodash';
import {ExtendedWrappedFieldExternalProps} from '../FormFields';
import FormInput from '../FormInput';
import FormPhotos from '../FormPhotos';
import {DISPLAY_TYPES, FieldsInfo} from '../FormSections/consts';
import TypedFormField from '../TypedFormField';
import {conditionFieldComponent} from './conditionFormFields';

export default function(fieldsInfo: FieldsInfo): ExtendedWrappedFieldExternalProps[] {
  // type should replace displayType
  const formFields: ExtendedWrappedFieldExternalProps[] = _.map(
    fieldsInfo,
    ({name, displayName, units, displayType, type, label, component, componentProps, ...props}) => {
      const infoBase = {
        name,
        label: label ? label : displayName || name,
        units,
        ..._.pick(props, breakpoints),
      };
      if (component) {
        return {
          ...infoBase,
          component,
          props: {...props, ...componentProps},
        };
      }
      switch (displayType) {
        case DISPLAY_TYPES.PHOTOS_PICKER:
          return {
            ...infoBase,
            component: FormPhotos,
            ..._.pick(props, 'resourceType'),
          };
        default:
          let typedComponent;
          let typedComponentProps = {};
          switch (type) {
            case 'shortString':
            case 'integer':
            case 'select':
            case 'float':
              typedComponent = TypedFormField;
              typedComponentProps = {
                type,
                ..._.pick(props, [
                  'options',
                  'creatable',
                  'maxLength',
                  'minLength',
                  'maxValue',
                  'minValue',
                  'decimalScale',
                  'valueFormatter',
                  'formatErrorMessage',
                  'disabledBy',
                  'disabledTooltip',
                ]),
                autoSelect: false,
              };
              break;
            default:
              typedComponent = FormInput;
              typedComponentProps = _.pick(props, ['disabledBy', 'disabledTooltip']);
              break;
          }
          return {
            ...infoBase,
            component: typedComponent,
            props: typedComponentProps,
          };
      }
    }
  );
  return _.map(formFields, (formField: ExtendedWrappedFieldExternalProps) =>
    conditionFieldComponent(formField.name, formField)
  );
}
